import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {PaginationInstance} from "ngx-pagination";
import {SimpleChanges} from "@angular/core";
declare var resetActions: Function;

@Component({ standalone: false, 
  selector: 'app-pagination-simulate',
  templateUrl: './pagination-simulate.component.html',
})
export class PaginationSimulateComponent implements OnInit, OnChanges {

  @Output() pageChanged: EventEmitter<number> = new EventEmitter<number>();
  @Input() id: string;
  @Input() currentPage: number;
  @Input() itemsPerPage: number;
  @Input() totalItems: number;
  config: PaginationInstance;
  constructor() {
    this.config = {id: this.id, currentPage: this.currentPage, itemsPerPage: this.itemsPerPage, totalItems: this.totalItems}
  }

  onPageChanged(pageInput: any) {
    if (!isNaN(Number(pageInput))  && Number.isInteger(Number(pageInput)) && pageInput > 0) {
      this.currentPage = Number(pageInput);
      this.config.currentPage = this.currentPage ;
      this.pageChanged.emit(this.currentPage);
    }
    this.resetActions(this.config.id);
  }

  resizeInput(pageInput: any, paginationField) {
    let lrBorderSize = 26;
    let charSize = 6;
    paginationField.setAttribute("style", "width: " + [lrBorderSize + (charSize * (pageInput.length + 2))] + 'px;');
  }

  nextPage() {
    this.config.currentPage = this.config.currentPage + 1;
    this.currentPage = this.config.currentPage;
    this.onPageChanged(this.currentPage)
  }

  previousPage() {
    this.config.currentPage  = this.config.currentPage - 1;
    this.currentPage = this.config.currentPage;
    this.onPageChanged(this.currentPage)
  }
  pageOne() {
    if (this.totalItems == 0) {
      this.totalItems = 1
    }
    this.config.currentPage = 1;
    this.currentPage = this.config.currentPage;
    this.onPageChanged(this.currentPage)
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      if(propName == 'id') {
        this.config[propName] = changes[propName].currentValue;
      } else  {
        this.config[propName] = Number(changes[propName].currentValue);
      }
    }
  }

  resetActions(id) {
    setTimeout(() => {
      resetActions(id);
    }, 500);
  }
}
